import * as OvationsApi from 'core/ovations-api';
import { mockCardRewardDetailsList } from './cardRewardDetail';

export const mockRewardSummaryItems: OvationsApi.Types.RewardSummary[] = [
    {
        id: '1',
        cardRewardDetail: mockCardRewardDetailsList[0],
        rewardCatalogItem: null,
        rewardType: OvationsApi.Enums.RewardType.Claims,
    },
    {
        id: '2',
        cardRewardDetail: mockCardRewardDetailsList[1],
        rewardCatalogItem: null,
        rewardType: OvationsApi.Enums.RewardType.Claims,
    },
    {
        id: '3',
        cardRewardDetail: null,
        rewardCatalogItem: {
            itemId: 1,
            title: 'Movie Ticket',
            status: 'Received',
            orderDate: '07-27-1982',
            orderNumber: 'AIMIC101206009803',
            quantity: 3,
            carrier: 'USPS',
            priceInPoints: 50,
            actualShipDate: '07-27-1992',
            estimatedShipDate: '07-27-2002',
        },
        rewardType: OvationsApi.Enums.RewardType.Catalog,
    },
    {
        id: '333',
        cardRewardDetail: null,
        rewardCatalogItem: {
            itemId: 1,
            title: 'DMovie Ticket',
            status: 'Received',
            orderDate: '07-27-1982',
            orderNumber: 'AIMIC101206009803',
            quantity: 3,
            carrier: 'USPS',
            priceInPoints: 50,
            actualShipDate: '07-27-1992',
            estimatedShipDate: '07-27-2002',
        },
        rewardType: OvationsApi.Enums.RewardType.Catalog,
    },
    {
        id: '31',
        cardRewardDetail: null,
        rewardCatalogItem: {
            itemId: 1,
            title: 'CMovie Ticket',
            status: 'Received',
            orderDate: '07-27-1982',
            orderNumber: 'AIMIC101206009803',
            quantity: 3,
            carrier: 'USPS',
            priceInPoints: 50,
            actualShipDate: '07-27-1994',
            estimatedShipDate: '07-27-2004',
        },
        rewardType: OvationsApi.Enums.RewardType.Catalog,
    },
    {
        id: '32',
        cardRewardDetail: null,
        rewardCatalogItem: {
            itemId: 1,
            title: 'BMovie Ticket',
            status: 'Received',
            orderDate: '07-27-1982',
            orderNumber: 'AIMIC101206009803',
            quantity: 3,
            carrier: 'USPS',
            priceInPoints: 50,
            actualShipDate: '07-27-1994',
            estimatedShipDate: '07-27-2004',
        },
        rewardType: OvationsApi.Enums.RewardType.Catalog,
    },
    {
        id: '33',
        cardRewardDetail: null,
        rewardCatalogItem: {
            itemId: 1,
            title: 'AMovie Ticket',
            status: 'Received',
            orderDate: '07-27-1982',
            orderNumber: 'AIMIC101206009803',
            quantity: 3,
            carrier: 'USPS',
            priceInPoints: 50,
            actualShipDate: '07-27-1993',
            estimatedShipDate: '07-27-2003',
        },
        rewardType: OvationsApi.Enums.RewardType.Catalog,
    },
    {
        id: '4',
        cardRewardDetail: null,
        rewardCatalogItem: {
            itemId: 114,
            title: 'Apple Watch0',
            status: 'Received',
            orderDate: '',
            orderNumber: 'AIMIC101206009803',
            quantity: 1,
            carrier: 'USPS',
            priceInPoints: 1233,
            actualShipDate: '07-27-1993',
            estimatedShipDate: '07-27-2003',
        },
        rewardType: OvationsApi.Enums.RewardType.Catalog,
    },
    {
        id: '5',
        cardRewardDetail: null,
        rewardCatalogItem: {
            itemId: 124,
            title: 'Toy Dinosaur0',
            status: 'Received',
            orderDate: '',
            orderNumber: 'FAKE',
            quantity: 1,
            carrier: 'USPS',
            priceInPoints: 3133,
            actualShipDate: '07-27-1993',
            estimatedShipDate: '07-27-2003',
        },
        rewardType: OvationsApi.Enums.RewardType.Catalog,
    },
    {
        id: '6',
        cardRewardDetail: null,
        rewardCatalogItem: {
            itemId: 144,
            title: 'Toy Dinosaur14',
            status: 'Shipped',
            orderDate: '',
            orderNumber: 'BIMIC101206009803',
            quantity: 1,
            carrier: 'USPS',
            priceInPoints: 4133,
            actualShipDate: '07-27-1994',
            estimatedShipDate: '07-27-2004',
        },
        rewardType: OvationsApi.Enums.RewardType.Catalog,
    },
    {
        id: '7',
        cardRewardDetail: null,
        rewardCatalogItem: {
            itemId: 154,
            title: 'Toy Dinosaur15',
            status: 'Received',
            orderDate: '',
            orderNumber: 'BIMIC101206009803',
            quantity: 1,
            carrier: 'USPS',
            priceInPoints: 1533,
            actualShipDate: '07-27-1994',
            estimatedShipDate: '07-27-2004',
        },
        rewardType: OvationsApi.Enums.RewardType.Catalog,
    },
    {
        id: '8',
        cardRewardDetail: null,
        rewardCatalogItem: {
            itemId: 164,
            title: 'Toy Dinosaur16',
            status: 'Received',
            orderDate: '',
            orderNumber: 'CIMIC101206009803',
            quantity: 1,
            carrier: 'USPS',
            priceInPoints: 1633,
            actualShipDate: '07-27-1994',
            estimatedShipDate: '07-27-2004',
        },
        rewardType: OvationsApi.Enums.RewardType.Catalog,
    },
    {
        id: '9',
        cardRewardDetail: null,
        rewardCatalogItem: {
            itemId: 174,
            title: 'Toy Dinosaur17',
            status: 'Received',
            orderDate: '',
            orderNumber: 'CIMIC101206009803',
            quantity: 1,
            carrier: 'USPS',
            priceInPoints: 1733,
            actualShipDate: '07-27-1994',
            estimatedShipDate: '07-27-2004',
        },
        rewardType: OvationsApi.Enums.RewardType.Catalog,
    },
    {
        id: '10',
        cardRewardDetail: null,
        rewardCatalogItem: {
            itemId: 184,
            title: 'Toy Dinosaur18',
            status: 'Received',
            orderDate: '',
            orderNumber: 'DIMIC101206009803',
            quantity: 1,
            carrier: 'USPS',
            priceInPoints: 1833,
            actualShipDate: '07-27-1994',
            estimatedShipDate: '07-27-2004',
        },
        rewardType: OvationsApi.Enums.RewardType.Catalog,
    },
    {
        id: '11',
        cardRewardDetail: null,
        rewardCatalogItem: {
            itemId: 194,
            title: 'Toy Dinosaur19',
            status: 'Received',
            orderDate: '',
            orderNumber: 'DIMIC101206009803',
            quantity: 1,
            carrier: 'USPS',
            priceInPoints: 1933,
            actualShipDate: '07-27-1994',
            estimatedShipDate: '07-27-2004',
        },
        rewardType: OvationsApi.Enums.RewardType.Catalog,
    },
    {
        id: '12',
        cardRewardDetail: null,
        rewardCatalogItem: {
            itemId: 204,
            title: 'Toy Dinosaur20',
            status: 'Received',
            orderDate: '',
            orderNumber: 'EIMIC101206009803',
            quantity: 1,
            carrier: 'USPS',
            priceInPoints: 2033,
            actualShipDate: '07-27-1994',
            estimatedShipDate: '07-27-2004',
        },
        rewardType: OvationsApi.Enums.RewardType.Catalog,
    },
    {
        id: '21',
        cardRewardDetail: null,
        rewardCatalogItem: {
            itemId: 4,
            title: 'Toy DinosaurA',
            status: 'Received',
            orderDate: '',
            orderNumber: 'EIMIC101206009803',
            quantity: 1,
            carrier: 'USPS',
            priceInPoints: 33,
            actualShipDate: '07-27-1994',
            estimatedShipDate: '07-27-2004',
        },
        rewardType: OvationsApi.Enums.RewardType.Catalog,
    },
    {
        id: '22',
        cardRewardDetail: null,
        rewardCatalogItem: {
            itemId: 4,
            title: 'Toy DinosaurZ',
            status: 'Received',
            orderDate: '',
            orderNumber: 'EIMIC101206009803',
            quantity: 1,
            carrier: 'USPS',
            priceInPoints: 33,
            actualShipDate: '07-27-1994',
            estimatedShipDate: '07-27-2004',
        },
        rewardType: OvationsApi.Enums.RewardType.Catalog,
    },
];
